import { createFileRoute, Link } from "@tanstack/react-router";
import { LegalPage } from "../components/legal-page";

export const Route = createFileRoute("/legal/terms")({
  head: () => ({
    meta: [
      { title: "Terms of Service" },
      { name: "description", content: "Terms governing use of the HR Service Centre website, free resources and online tools." },
      { property: "og:title", content: "Terms of Service" },
      { property: "og:url", content: "https://www.hrservicecentre.co.uk/legal/terms" },
    ],
    links: [{ rel: "canonical", href: "https://www.hrservicecentre.co.uk/legal/terms" }],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <LegalPage
      title="Terms of Service"
      intro="By using this website you agree to these terms. They are governed by the laws of England & Wales."
      lastReviewed="2026-09-14"
    >
      <h2>Who we are</h2>
      <p>
        This website is operated by HR Service Centre (powered by EmployerHQ), 20-22 Wenlock Road, London, N1 7GU.
      </p>

      <h2>Use of the website</h2>
      <p>
        You may use this site for lawful, personal and business research purposes. You may not scrape, mirror or
        republish substantial portions of our content without written permission.
      </p>

      <h2>Free resources and tools</h2>
      <p>
        Our calculators (including redundancy pay, holiday entitlement, statutory sick pay, maternity and paternity
        pay, notice periods, national minimum wage and unfair dismissal), document templates, glossary, guides and
        helpline pages provide general information based on UK statutory rates current at the last reviewed date shown
        on each page. They do not constitute legal advice and should not be relied on for decisions affecting
        individuals. Always take advice on your specific circumstances.
      </p>

      <h2>Templates</h2>
      <p>
        Templates downloaded from this site may be adapted and used within your own organisation. You are responsible
        for checking that the final document fits your circumstances and current law. Redistribution or resale is not
        permitted.
      </p>

      <h2>Third-party links and partners</h2>
      <p>
        Some pages link to third-party sites and partner organisations, which may be marked as sponsored. We are not
        responsible for their content, services or privacy practices.
      </p>

      <h2>Engagement of services</h2>
      <p>
        Paid services are governed by a separate engagement letter signed between you and HR Service Centre. Those
        terms prevail over anything on this website to the extent of any conflict.
      </p>

      <h2>Liability</h2>
      <p>
        To the maximum extent permitted by law, we exclude liability for loss arising from reliance on free content on
        this site. Nothing in these terms excludes liability for fraud, death or personal injury caused by negligence,
        or for matters that cannot be limited under English law.
      </p>

      <h2>Intellectual property</h2>
      <p>
        All content, branding and templates are © HR Service Centre unless stated otherwise.
      </p>

      <h2>Privacy</h2>
      <p>
        How we handle personal data is set out in our <Link to="/legal/privacy">Privacy Policy</Link>.
      </p>

      <h2>Changes to these terms</h2>
      <p>
        We may update these terms from time to time. The last reviewed date at the top of this page shows when they
        were last changed.
      </p>

      <h2>Governing law</h2>
      <p>
        These terms are governed by the laws of England &amp; Wales and the courts of England &amp; Wales have
        exclusive jurisdiction.
      </p>
    </LegalPage>
  );
}
